import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import NewMeetingLocation
  from './NewMeetingLocation';

export default buildFacetDesignOverride()
  .nameOverride('location', {
    _component: () => NewMeetingLocation,
  }, overrideReadOnly);
